<template>
    <div
        class="rounded flex items-stretch justify-between bg-white border has-[:focus]:border-semantic-info has-[:disabled]:border-primary-20 has-[:disabled]:bg-primary-5 has-[:disabled]:text-primary-60"
        :class="[error ? 'border-semantic-error' : button ? 'border-primary-40' : 'border-primary-80']"
    >
        <component
            :is="button ? 'button' : 'input'"
            :type="type"
            class="rounded-l h-full flex-grow outline-none px-16 hover:bg-primary-20"
            :class="button ? 'py-8' : 'py-12'"
            :ref="button ? 'button' : 'input'"
            @click="button ? $emit('click') : focus"
        >
            <slot>{{ capitalize(inputLabel) }}</slot>
        </component>
        <div
            class="rounded-r border-l flex items-center justify-center bg-white hover:bg-primary-20"
            :class="[error ? 'border-semantic-error' : button ? 'border-primary-40' : 'border-primary-80']"
        >
            <slot name="button">
                <div class="px-8 h-full" @click="$emit('buttonClick')">
                    <svg-icon type="add-circle" class="w-18 h-18 fill-secondary" />
                </div>
            </slot>
        </div>
    </div>
</template>
<script>
import {ucfirst} from "../../../shared/helpers";
import SvgIcon from "../ui/SvgIcon.vue";

export default {
    name: "DoubleInput",
    components: {
        SvgIcon,
    },
    props: {
        button: Boolean,
        type: String,
        inputLabel: String,
        errors: Array,
    },
    computed: {
        error() {
            if (!this.errors) {
                return null;
            }
            return Array.isArray(this.errors) ? this.errors[0] : this.errors;
        }
    },
    methods: {
        focus() {
            if (this.$refs.input || null) {
                this.$refs.input.focus();
            }
        },
        capitalize(string) {
            return ucfirst(string)
        }
    }
}
</script>